import { render, staticRenderFns } from "./PontoConsultaFichaPonto.vue?vue&type=template&id=b74dbf4e&"
import script from "./PontoConsultaFichaPonto.vue?vue&type=script&lang=js&"
export * from "./PontoConsultaFichaPonto.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PontoConsultaFichaPonto.vue?vue&type=style&index=1&id=b74dbf4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports